import store from '../store'
import _ from 'lodash'
import { httpClient as http } from '../services'

const internals = {}

internals.exportData = modelName => {
  return http
    .get(`/v1/exportMaster?model=${modelName}`)
    .then(response => {
      return response
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}


export default internals



// WEBPACK FOOTER //
// ./src/services/export.service.js